import { render, staticRenderFns } from "./RegistrationAgreement.vue?vue&type=template&id=0c6b5b14&scoped=true"
import script from "./RegistrationAgreement.vue?vue&type=script&lang=js"
export * from "./RegistrationAgreement.vue?vue&type=script&lang=js"
import style0 from "./RegistrationAgreement.vue?vue&type=style&index=0&id=0c6b5b14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b5b14",
  null
  
)

export default component.exports